import React from 'react';

const NotFound = () => {
    return (
        <div className="player-main-surface" style={{ padding: "2rem", textAlign: "center" }}>
            Not Found
        </div>
    );
}

export default NotFound;
